import { type ThunkAction, type ThunkDispatch } from "@reduxjs/toolkit";
import { type RestaurantBranding } from "api-types";

import { type ReduxState } from "../../types/reduxState";
import { type ThunkExtraArgument } from "../../types/thunk";
import { type BrandingReducerAction } from "../reducers/brandingReducer";
import { type ErrorReducerAction } from "../reducers/errorReducer";
import { addError } from "./addErrorAction";

export const setRestaurantBranding: (
  restaurantUuid: string,
  restaurantBranding: RestaurantBranding
) => ThunkAction<
  void,
  ReduxState,
  ThunkExtraArgument,
  BrandingReducerAction
> = (restaurantUuid: string, restaurantBranding: RestaurantBranding) => {
  return (
    dispatch: ThunkDispatch<
      ReduxState,
      ThunkExtraArgument,
      BrandingReducerAction | ErrorReducerAction
    >,
    getState: () => ReduxState,
    { brandingApi }: ThunkExtraArgument
  ) => {
    dispatch({ type: "UPDATING_BRANDING", payload: true });
    brandingApi
      .setBranding(restaurantUuid, restaurantBranding)
      .then(() => {
        dispatch({ type: "SET_BRANDING", payload: restaurantBranding });
      })
      .catch((err: any) => {
        dispatch({ type: "UPDATING_BRANDING", payload: false });
        addError(dispatch)(err);
      });
  };
};

export const fetchRestaurantBranding: (
  restaurantUuid: string,
  onError: (err: Error) => void
) => ThunkAction<
  void,
  ReduxState,
  ThunkExtraArgument,
  BrandingReducerAction
> = (restaurantUuid: string, onError: (err: Error) => void) => {
  return (
    dispatch: ThunkDispatch<
      ReduxState,
      ThunkExtraArgument,
      BrandingReducerAction
    >,
    getState: () => ReduxState,
    { brandingApi }: ThunkExtraArgument
  ) => {
    brandingApi
      .fetchBranding(restaurantUuid)
      .then((branding) => {
        dispatch({ type: "FETCHED_BRANDING", payload: branding });
      })
      .catch(onError);
  };
};
